import {
  compile
} from 'handlebars';
import EmployerPendingsUI from '../../../dictionaries/EmployerPendingsUI.dic';
import {
  join
} from '../../../lib/Array.lib';
import {
  CSS_GRAY_RGB
} from '../../../lib/Constants';
import Core from '../../../lib/Core';
import Employer from '../../../lib/Employer';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import {
  Fun
} from '../../../lib/Function.lib';
import {
  NOT
} from '../../../lib/GenericTools.lib';
import {
  extractVisibleText,
  joinHTML
} from '../../../lib/HTML.lib';
import {
  Obj
} from '../../../lib/Object.lib';
import {
  FirstWord,
  compileText,
  trim
} from '../../../lib/String.lib';
import useState from '../../../lib/hooks/useState.hook';
import {
  getNewEmployerEmailTemplateStructure
} from '../../../lib/models/employerEmailTemplate.model';
import {
  TEN_BY_TEN_RECRUITER_EMAIL_OBJECT,
  sendSafeEmail
} from '../../../lib/services/Email/Email.lib';
import EmailPreview, {
  EMAIL_DIALOG_PANEL__EDIT
} from '../../Dialogs/EmailPreview';
import Box from '../../Layout/Wrappers/Box';
import Button from '../../Layout/Wrappers/Button';
import Icon from '../../Layout/Wrappers/Icon';
import {
  WarningChipMessage
} from '../../Layout/Wrappers/Message';
import { PLACEMENT__TOP_START } from '../../Layout/Wrappers/StyledTooltip';
import Loader from '../../Shared/Loader';
import {
  EMPLOYER_MANAGE_TEMPLATES_TOKEN__CANDIDATE__FIRSTNAME,
  EMPLOYER_MANAGE_TEMPLATES_TOKEN__CANDIDATE__LASTNAME,
  EMPLOYER_MANAGE_TEMPLATES_TOKEN__CANDIDATE__NICKNAME,
  EMPLOYER_MANAGE_TEMPLATES_TOKEN__EMPLOYER_NAME,
  EMPLOYER_MANAGE_TEMPLATES_TOKEN__MY_FIRSTNAME
} from '../EmployerManageTemplates/EmployerManageTemplatesContent';
import {
  EmployerTemplateBar,
  getControllerEmployerTemplateBar
} from '../EmployerManageTemplates/EmployerTemplateBar';
import {
  getEmployerPendingsController
} from './EmployerPendings';
import {
  EMPLOYER__PROCESSING_MODEL_KEY__CALIBRATION_FEEDBACK
} from './Libraries/EmployerPendings.dic';

export function MessageEmployerToCandidate({
  context,
  appendText
}) {
  const [state, updateState] = useState({});
  const {
    selected,
    employer
  } = context;
  if (!employer?.id) { return; }

  /**
   * Intialize emailTemplate on memory
   * if not exists assign the employer emailTemplate
   * if not exists assign the default emailTemplate
   */
  if (NOT(selected.emailTemplate)) {
    selected.emailTemplate = {
      ...Obj(
        employer.emailTemplate?.hash?.[Core.getUserId()]
        || getNewEmployerEmailTemplateStructure()?.hash?.[Core.getUserId()]
      )
    };
  }

  /**
   * This event function was an attempt to distingush between 
   * User edits and RTB edits, but it doesn't really work
   * Certain scenarios can't be distinguished like switching between tabs
   * And that is the main reason why we can't use it to reset
   * the template state when the user edits the email
   * But we stiil need to do this to make sure
   * the emailTemplate on memory is updated
   */
  const onUserEdit = async () => {
    const currentEmail = getControllerMessageEmployerToCandidateEmailPreview().getParams();
    Object.assign(selected.emailTemplate, {
      subject: currentEmail.subject,
      greetings: currentEmail.greetings,
      body: currentEmail.html
    });
    if (selected.emailTemplate.templateId) {
      const TemplateBar = getControllerEmployerTemplateBar();
      const template = TemplateBar.replaceMacros(Obj(TemplateBar.state?.selected));
      const SUBJECT__TEMPLATE = extractVisibleText(template.subject);
      const BODY__TEMPLATE = extractVisibleText(template.body);
      const SUBJECT__EDITOR = extractVisibleText(selected.emailTemplate.subject);
      const BODY__EDITOR = extractVisibleText(selected.emailTemplate.body);
      console.debug('onEmailSent',
        '\n', SUBJECT__TEMPLATE,
        '\n', SUBJECT__EDITOR,
        '\n', BODY__TEMPLATE,
        '\n', BODY__EDITOR
      );
      if (
        (SUBJECT__TEMPLATE !== SUBJECT__EDITOR)
        ||
        (BODY__TEMPLATE !== BODY__EDITOR)
      ) {
        selected.emailTemplate.templateId = null;
        TemplateBar.reset();
      }
    }
    await updateState();
  };

  const userFirstname = FirstWord(Core.getUserName());
  const greetings = '';
  const prefix = compileText(trim(`
    <i style="color: {{COLOR}}">
      Sent by 10 By 10 on behalf of {{EMPLOYER__NAME}}.<br/>
      Please reply all to make sure you respond to both the employer and 10 By 10
    </i>
  `), {
    COLOR: CSS_GRAY_RGB,
    USER__NAME: Core.getUserName(),
    EMPLOYER__NAME: employer.name
  });

  const onClickSendEmail = async (event) => {
    await updateState({ busy: true });
    try {
      // Contains the recipients: to, cc, bcc. Also used as a flag in render to disable the SEND button
      selected.emailSent = getControllerMessageEmployerToCandidateEmailPreview().getParams();

      // Send email
      await sendSafeEmail({
        ...selected.emailSent, // This contains the recipients: to, cc, bcc
        ...selected.emailTemplate, // This contains the subject, greetings and body
        html: join([
          !!prefix && `${prefix}<hr/>`,
          !!greetings && `<div>${greetings}</div>`,
          selected.emailTemplate.body
        ], ''),
        boxKey: selected.boxKey,
        source: 'Email.lib.js'
      });

      // Update emailTemplate for employer
      const update = {
        emailTemplate: {
          ...employer.emailTemplate,
          hash: {
            ...employer.emailTemplate?.hash,
            [Core.getUserId()]: {
              ...selected.emailTemplate
            }
          }
        }
      };

      // If templateId exists, remove subject, greetings and body
      if (update.emailTemplate.hash[Core.getUserId()].templateId) {
        delete update.emailTemplate.hash[Core.getUserId()].subject;
        delete update.emailTemplate.hash[Core.getUserId()].greetings;
        delete update.emailTemplate.hash[Core.getUserId()].body;
      }

      // Remove emailTemplate.list (patch old structure)
      delete update.emailTemplate.list;

      // Update employer on server DB
      await Employer.update(employer.id, update);

      // Update memory state
      const EmployerPendings = getEmployerPendingsController();
      const data = removeEmailTemplateDeep(EmployerPendings.state?.data);
      Object.assign(data.employer, update);
      await EmployerPendings.updateState({ data });

    }
    catch (error) {
      globalErrorHandler(error);
    }
    setTimeout(() => {
      updateState({ busy: false });
    }, 1000);
  }

  const emailSent = Obj(selected.emailSent);
  const currentEmail = Obj(Fun(getControllerMessageEmployerToCandidateEmailPreview().getParams)());

  const YES__CALIBRATION = (
    selected.engagementKey === EMPLOYER__PROCESSING_MODEL_KEY__CALIBRATION_FEEDBACK
  );
  const YES__BUSY = !!state.busy;
  const YES__EMAIL_SENT = !!selected.emailSent;

  const SUBJECT__EMPLOYER = extractVisibleText(employer.emailTemplate?.hash?.[Core.getUserId()]?.subject);
  const SUBJECT__EDITOR = extractVisibleText(selected.emailTemplate.subject);
  const SUBJECT__SENT = extractVisibleText(emailSent.subject);
  const BODY__EMPLOYER = extractVisibleText(employer.emailTemplate?.hash?.[Core.getUserId()]?.body);
  const BODY__EDITOR = extractVisibleText(selected.emailTemplate.body);
  const BODY__SENT = extractVisibleText(emailSent.html);

  const YES__EDITOR_MATCH_EMPLOYER = (
    (SUBJECT__EMPLOYER === SUBJECT__EDITOR)
    &&
    (BODY__EMPLOYER === BODY__EDITOR)
  );

  const YES__EDITOR_MATCH_EMAIL_SENT = (
    (SUBJECT__SENT === SUBJECT__EDITOR)
    &&
    (BODY__SENT === BODY__EDITOR)
  );

  const YES__DISABLED__BUTTON__SEND = (
    YES__BUSY ||
    YES__CALIBRATION ||
    (YES__EMAIL_SENT && YES__EDITOR_MATCH_EMAIL_SENT)
  );

  const NOT__TEMPLATE_SELECTED = NOT(
    selected.emailTemplate?.templateId
  );

  console.debug(
    'MessageEmployerToCandidate\n',
    {
      emailSent,
      currentEmail,
      emailTemplate: selected.emailTemplate
    }
  );

  return (
    <>
      <EmailPreview
        ref={setControllerMessageEmployerToCandidateEmailPreview}
        {...({
          editDisclaimer: (
            <div className='f-md f-italic c-black-medium mb-2'>
              Create/Edit email to candidate. Defaults to most recent message sent from platform.
            </div>
          ),
          previewDisclaimer: (
            <div className='f-md f-italic c-black-medium mb-2'>
              Preview email to candidate.
            </div>
          ),
          to: YES__CALIBRATION ? [] : [
            {
              accountType: 'Candidate Contact',
              name: selected.candidate._name,
              email: selected.candidate.email
            }
          ],
          cc: YES__CALIBRATION ? [] : [
            {
              accountType: 'User',
              name: Core.getUserName(),
              email: Core.getSessionEmail()
            },
            TEN_BY_TEN_RECRUITER_EMAIL_OBJECT
          ],
          templateBar: (
            <EmployerTemplateBar
              employerId={employer.id}
              templateId={selected.emailTemplate.templateId}
              onChange={async template => {
                getControllerMessageEmployerToCandidateEmailPreview().setTemplate(template);
                Object.assign(selected.emailTemplate, {
                  templateId: template.id,
                  subject: template.subject,
                  body: template.body
                });
              }}
              macros={{
                [EMPLOYER_MANAGE_TEMPLATES_TOKEN__MY_FIRSTNAME]: userFirstname,
                [EMPLOYER_MANAGE_TEMPLATES_TOKEN__CANDIDATE__NICKNAME]: selected.candidate.nickName,
                [EMPLOYER_MANAGE_TEMPLATES_TOKEN__CANDIDATE__FIRSTNAME]: selected.candidate.firstName,
                [EMPLOYER_MANAGE_TEMPLATES_TOKEN__CANDIDATE__LASTNAME]: selected.candidate.lastName,
                [EMPLOYER_MANAGE_TEMPLATES_TOKEN__EMPLOYER_NAME]: employer.name,
              }}
            />
          ),
          subject: compileText(
            trim(selected.emailTemplate.subject),
            { EMPLOYER__NAME: employer.name || '[ employer_name ]' }
          ),
          prefix,
          // greetings,
          body: compile(
            join([
              patchOldParagraphFormat(selected.emailTemplate.body),
              patchOldParagraphFormat(appendText)
            ], '')
          )({
            USER__FIRSTNAME: userFirstname || '[ your name ]'
          }),
          copyText: `$to $from $subject $body`,
          showFrom: true,
          panel: EMAIL_DIALOG_PANEL__EDIT,
          enablePanels: true,
          onUserEdit
        })}
      />
      <Box row className='bg-white p-1 space-between'
        style={{
          position: 'sticky',
          bottom: -5,
          zIndex: 1,
        }}
      >
        <Box row>
          <Button small
            title={
              YES__DISABLED__BUTTON__SEND &&
              'Email already sent or in calibration process'
            }
            className='min-w-160 mr-1'
            disabled={YES__DISABLED__BUTTON__SEND}
            onClick={onClickSendEmail}
          >
            {
              (
                YES__BUSY
              ) ? (
                <Loader
                  className='c-white'
                >
                  Sending...
                </Loader>
              ) : (
                YES__DISABLED__BUTTON__SEND
              ) ? (
                'Email sent'
              ) : (
                'Send'
              )
            }
          </Button>
          <Icon
            icon='info'
            title={EmployerPendingsUI.MessageEmployerToCandidate.Icon.info}
            placement={PLACEMENT__TOP_START}
            className='c-black-dark'
          />
        </Box>
        <WarningChipMessage
          show={NOT__TEMPLATE_SELECTED && YES__EDITOR_MATCH_EMPLOYER}
          className='p-1'
          style={{ height: 32 }}
        >
          {EmployerPendingsUI.MessageEmployerToCandidate.WarningChipMessage.note}
        </WarningChipMessage>
      </Box>
    </>
  );
}

export function getControllerMessageEmployerToCandidateEmailPreview() {
  return Obj(Core.getKeyValue('MessageEmployerToCandidate_EmailPreview'));
}

export function setControllerMessageEmployerToCandidateEmailPreview(controller) {
  Core.setKeyValue('MessageEmployerToCandidate_EmailPreview', controller);
}

export function patchOldParagraphFormat(html) {
  return joinHTML(html)
    .replace(/<p>/gi, '')
    .replace(/,<\/p>/gi, ',<br/>')
    .replace(/<\/p>/gi, '<br/><br/>');
}

/**
 * removeEmailTemplateDeep
 *
 * Iteratively removes the `emailTemplate` property from any object
 * found within a deeply nested data structure.
 *
 * HOW IT WORKS
 * ------------
 * This function performs a depth-first traversal without recursion.
 * Instead of relying on the call stack, it uses an explicit stack
 * (LIFO array) to keep track of values that still need to be processed.
 *
 * The algorithm treats the input as a graph, not a tree.
 * This is important because real-world JavaScript objects may contain
 * circular or shared references.
 *
 * To safely handle this, a WeakSet is used to track already-visited
 * objects and arrays. If an object has been processed before, it is
 * skipped to prevent infinite loops.
 *
 * TRAVERSAL STEPS
 * --------------
 * 1. Initialize a stack with the root value.
 * 2. While the stack is not empty:
 *    a. Pop the last value from the stack.
 *    b. Ignore non-objects (primitives, null, undefined).
 *    c. If the object was already visited, skip it.
 *    d. Mark the object as visited.
 *    e. If the object has an `emailTemplate` property, delete it.
 *    f. Push all nested values (array items or object properties)
 *       onto the stack for later processing.
 *
 * WHY ITERATIVE
 * -------------
 * - Avoids "Maximum call stack size exceeded" errors.
 * - Works safely with cyclic references.
 * - More robust for large or complex object graphs.
 *
 * MUTATION
 * --------
 * This function mutates the original object in place.
 * All deletions happen on the provided reference.
 *
 * COMPLEXITY
 * ----------
 * Time:   O(n) — each object is visited once
 * Space:  O(n) — visited references + traversal stack
 *
 * @param {*} value
 *   Any JavaScript value (object, array, or primitive).
 *
 * @returns {*}
 *   The same reference passed as input, with all `emailTemplate`
 *   properties removed.
 */
function removeEmailTemplateDeep(value) {
  // Keeps track of objects that were already processed
  // WeakSet prevents memory leaks and allows garbage collection
  const visited = new WeakSet();

  // Explicit stack used to replace recursive calls (LIFO)
  const stack = [value];

  // Process elements until there is nothing left to traverse
  while (stack.length > 0) {
    // Get the next value to process
    const current = stack.pop();

    // Ignore primitives, null, and undefined
    if (!current || typeof current !== "object") {
      continue;
    }

    // Skip objects that were already visited
    // This prevents infinite loops caused by circular references
    if (visited.has(current)) {
      continue;
    }

    // Mark the current object as visited
    visited.add(current);

    // Remove the emailTemplate property if it exists
    if ("emailTemplate" in current) {
      delete current.emailTemplate;
    }

    // If the current value is an array,
    // push each item onto the stack for later processing
    if (Array.isArray(current)) {
      for (const item of current) {
        stack.push(item);
      }
    } else {
      // If the current value is a plain object,
      // push each property value onto the stack
      for (const key in current) {
        stack.push(current[key]);
      }
    }
  }

  // Return the same reference that was passed in
  // (the mutation is done in place)
  return value;
}
